export const translations = {
  widgetTitle: '<strong>AI</strong> Advisor',
  widgetTooltip: 'Hi, any questions?',
  title: 'AI Advisor',
  inputPlaceholder: 'Type your question',
  sendMessageButton: 'Send Message',
  poweredBy: 'Powered by',
  multiChoiceFindButton: 'Find it',
  failedMessage: 'Message not sent. Tap to retry',
  addToCartButton: 'Add to cart',
  errors: {
    default: "Apologies, I'm currently unavailable. Please try again later.",
    emptyChatId: 'Chat ID is empty',
    notInitialized: 'Chat is not initialized. Please try again.',
    connectionFailure: 'Connection failure. Please try again.',
    noConnection: 'Unable to connect. Please check your internet connection and try again.',
    messageTooLong: 'Message is too long. Please shorten it.',
    messageNotDelivered: 'Message not delivered. Please try again.',
    addToCartFailure: 'Error adding the item to the cart. Please try again later.',
  },
  variants: {
    label: (optionName: string) => `Choose ${optionName}`,
    emptySelectError: (optionsNames: string[]) => `Opps you didn’t select ${optionsNames.join(', ').toLowerCase()}`,
    pleaseSelect: 'Please select',
  },
};

export type TranslationsType = typeof translations;
